import loadable from "@loadable/component";

export const QuestionnairePage = loadable(() => import("./QuestionnairePage"), {
  resolveComponent: mod => mod.QuestionnairePage,
});

export * from "./types";
